import { Component, EventEmitter, OnInit, Input, Output, ViewChild } from '@angular/core';
import { Router }            from '@angular/router';
import {Message, OverlayPanel, SelectItem, ConfirmDialog, ConfirmationService, SplitButton, MenuItem} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as enums from '../../enums/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

//components
import {MessageHandlerComponent} from '../../components/Controls/MessageHandler.component';
import {BlockComponent} from '../../components/Controls/Block.component';

//base
import { BaseDomainDataGridComponent }         from '../../baseclasses/BaseDomainDataGrid';

@Component({
  selector: 'my-requesttype-grid',
  templateUrl: './RequestTypeGrid.component.html'
})
export class RequestTypeGridComponent extends BaseDomainDataGridComponent {

    @ViewChild(MessageHandlerComponent) messageHandlerComponent: MessageHandlerComponent;
    @ViewChild(BlockComponent) blockComponent: BlockComponent;

    userInfo: ent.UserInfo;
    records: ent.RequestType[];
    cols: any[];

    constructor(private authenticationService: serv.AuthenticationService, private domainDataService: serv.DomainDataService,
         private router: Router) 
    {
        super();
    }

    ngOnInit(): void {
        this.userInfo = this.authenticationService.getUserInfo();
        //this.recordEditComponent.subtradeChannelDropdownComponent.load();
        this.loadColumns();
        this.onSearchClick(null);
    }

    loadColumns(){
        //Note: this is only needed for the p-table exportCSV function to work. Without loading the columns, that will throw an error.
        this.cols = [
            { field: 'ID', header: 'ID' },
            { field: 'Name', header: 'Name' },
            { field: 'SubmitUsingAPI', header: 'Submit Using API' },
            { field: 'APIActive', header: 'API Active' }
        ];
    }

    
    
    onSearchClick(event: any){
        this.blockComponent.blocked = true;
        this.domainDataService.getRequestTypes().subscribe(x=>{
            this.records = x;
            this.blockComponent.blocked = false;
        }, err => {
            this.messageHandlerComponent.handleResponse({Success: false, ValidationMessages: [{Category: "error", MessageText: err}]})
            this.blockComponent.blocked = false;
        });
    }

    showActivateButton(rt: ent.RequestType) : boolean {
        return rt.SubmitUsingAPI && !rt.APIActive;
    }
    showDeactivateButton(rt: ent.RequestType) : boolean {
        return rt.SubmitUsingAPI && rt.APIActive;
    }

    onActivateAPI(event: any, rt: ent.RequestType) {
        rt.APIActive = true;
        this.doSave(rt);
    }
    onDeactivateAPI(event: any, rt: ent.RequestType) {
        rt.APIActive = false;
        this.doSave(rt);
    }

    doSave(rt: ent.RequestType) {
        var request: ent.SaveRequestTypeRequest = {RequestType: rt, SavedByEmployee: this.userInfo.Employee};
        
        this.domainDataService.saveRequestType(request).subscribe(x=>{
            this.messageHandlerComponent.handleResponse(x);
            this.onSearchClick(null);
        });
    }
}